/** 引用axios **/
import axios from "axios";
import router from "@/router";
import { getIe8n } from "@/utils/auth";
import { addApplogFn, replaceData } from "@/utils/util";
import { Loading } from "element-ui";
import { message } from "@/utils/resetMessage";
import store from "@/store";
let loading; // loading动画服务实例
let index = 0; // 正在载入的个数
// const redirectHref = process.env.NODE_ENV === 'development' ? '/views/Login' : './'
/** 全局配置 **/
// axios.defaults.timeout = 180000;
// 配置token
if (localStorage.getItem("loginToken")) {
  // axios.defaults.headers.common['Authorization'] = localStorage.getItem('loginToken'); // 存储登录验证token
}
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 1000 * 60 * 60, // request timeout
});
/** 请求拦截器 **/
service.interceptors.request.use(
  (config) => {
    if (getIe8n()) {
      config.headers["Accept-Language"] = getIe8n();
    }
    try {
      if (!Array.isArray(config.log)) {
        message.warning("请在接口中传入log！");
      } else {
        Object.assign(
          config.headers,
          addApplogFn(config.log, router.currentRoute)
        );
        delete config.log;
      }
    } catch {
      message.warning("请在接口中传入log！");
    }
    if (!config.params || config.params.loading !== false) {
      let loadText = "载入中..."
      if(getIe8n()=='en'){
        loadText = "loading..."
      }
      loading = Loading.service({
        lock: true,
        text: loadText,
        spinner: "el-icon-loading",
        background: "rgba(166, 197, 235, 0.1)",
        customClass: "",
      });
      index++;
    } else {
      delete config.params.loading;
    }
    if (config.method === "post" && config.data instanceof FormData !== true) {
      // 判断非上传文件
      if (Object.prototype.toString.call(config.data) === "[object Array]") {
        config.data = config.data;
      } else {
        config.data = {
          ...config.data,
          _t: Date.parse(new Date()) / 1000,
        };
      }
    } else if (config.method === "get") {
      config.params = {
        _t: Date.parse(new Date()) / 1000,
        ...config.params,
      };
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/** 响应拦截器 **/
service.interceptors.response.use(
  (res) => {
    // 拦截代码，根据业务需求自己写
    // 请求结束loadding动画
    index--;
    if (index < 1) {
      if (loading) loading.close();
      index = 0;
    }
    // eslint-disable-next-line eqeqeq
    if (res.data.code === "Auth_401" && router.currentRoute.name !== "Login") {
      router.push({
        name: "Login",
      });
      return res;
    }
    if (
      res.status === 200 &&
      (res.data.ok || !res.data.message) &&
      !(
        res.data instanceof Blob ||
        res.headers["content-type"] ===
          "application/force-download;charset=utf-8"
      )
    ) {
      return replaceData(res.data);
    } else if (
      res.data instanceof Blob ||
      res.headers["content-type"] === "application/force-download;charset=utf-8"
    ) {
      //判断是Blob对象返回
      return res;
    } else {
      message.error(res.data.message);
      return Promise.reject(new Error(res.data.message || "Error"));
    }
  },
  (error) => {
    if (error.response.status === 401) {
      if (
        router.currentRoute.path !== "/" &&
        router.currentRoute.path !== "/login"
      ) {
        message.error("登录过期，请重新登录");
        store.commit("user/SET_USID", "");
        router.push("/login");
      }
      index = 0;
      if (loading)loading.close();
    } else {
      index--;
      if (index < 1) {
        if (loading) loading.close();
        index = 0;
      }
      message.error("网络异常，请联系管理员");
      return Promise.reject(new Error(error.response.message || "Error"));
    }
    return Promise.reject(error.response?error.response.response:error.response);
  }
);

export default service;
